import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useReprintOrderMutation } from "store/apis/OrdersApi";
import PrintIcon from "@mui/icons-material/Print";

export function OrderDetailContent({ submittedOrderById, lastSelectedOrderId }) {
  
  const [
    reprintOrder,
  ] = useReprintOrderMutation();

  const handleReprint = (orderId) => {
    reprintOrder(orderId);
  }

  //wait for API to return order details when this 
  //is still populated with last order details viewed
  if (!submittedOrderById 
    ||(lastSelectedOrderId !== submittedOrderById?.orderId)) {
    return (<div> </div>);
  }

  return (
    <Box
      display="flex"
      width="50%"
      flexWrap="wrap"
      height="auto"
      marginLeft="3rem"
      marginY="1rem"
    >
      {submittedOrderById?.items?.map((item, idx) => {
        return (
          <Box
            key={`${idx}-${item.description}`}
            width="100%"
            borderBottom="1px solid grey"
            paddingY=".25rem"
            display="flex"
            flexWrap="wrap"
            justifyContent="flex-start"
          >
              <Typography>
                {item.description}
              </Typography>
              <Typography 
                sx={{
                  marginLeft: "auto", 
                  marginRight: "1rem"
                }}
              >
                {item.quantity}
              </Typography>
            <Box component="div" width="100%">
              {!!item?.allergyNote && <p style={{marginLeft: "1rem"}}><i>{item.allergyNote}</i></p>}
              {!!item?.removedItems?.length && item.removedItems.map((rem, idx) => {
                return <p key={idx} style={{marginLeft: "1rem"}}><i>Remove: {rem.text} (ALLERGY)</i></p>
              })}
              {!!item?.specialNote && <p style={{marginLeft: "1rem"}}>Special Note: {item.specialNote}</p>}
              {!!item?.subItems?.length && item.subItems.map((sub, idx) => {
                return <p key={idx} style={{marginLeft: "1rem"}}>Add - {sub.description} ({sub.quantity})</p>
              })}
            </Box>
          </Box>
        )
      })}
      <Button
        variant="contained"
        size="small"
        sx={{ marginTop: ".5rem", fontWeight: "bold" }}
        startIcon={<PrintIcon />}
        onClick={() => handleReprint(submittedOrderById.orderId)}
        disabled={!submittedOrderById?.isPrinted}
      >
        Reprint
      </Button>
    </Box>
  );
}